import { render } from "./VinksPartner.vue?vue&type=template&id=3ca7b73e&scoped=true"
import script from "./VinksPartner.vue?vue&type=script&lang=js"
export * from "./VinksPartner.vue?vue&type=script&lang=js"

import "./VinksPartner.vue?vue&type=style&index=0&id=3ca7b73e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca7b73e"]])

export default __exports__